import { css, cx } from "@emotion/css";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { grey, white } from "@/modules/theme/utils/colors";
import { fade } from "@/modules/theme/utils/fade";
import { ButtonVariants } from "@/modules/theme/utils/types";

import { Loader } from "./Loader";

interface ButtonLoaderProps {
  variant?: "neutral" | ButtonVariants;
}

export const ButtonLoader = ({ variant }: ButtonLoaderProps) => {
  const { palette } = useTheme();
  const classes = {
    root: css({
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
    }),

    neutral: css({
      borderColor: fade(grey[500], 0.7),
      borderTopColor: white,
    }),

    primary: css({
      borderTopColor: palette.primary.text,
    }),

    secondary: css({
      borderTopColor: palette.secondary.text,
    }),

    tertiary: css({
      borderTopColor: palette.tertiary.text,
    }),

    warning: css({
      borderTopColor: palette.error.text,
    }),

    text: css({
      borderTopColor: palette.secondary.textDark,
      left: "105%",
      top: 0,
    }),
  };
  return (
    <div className={classes.root}>
      <Loader className={cx(variant && classes[variant])} size={20} />
    </div>
  );
};
